export default __webpack_public_path__ + "static/media/myaccount-bg.6706b46f.svg";